import React from "react";
import { CreateQuestionnaireScope, DeleteQuestionnaireScope, Questionnaire, QuestionnaireScopeAPIModel, QuestionnaireViewModel } from "../utils/ServiceManagerAPI";
import StyledModal from "./StyledModel";
import { useUser } from "../utils/AccountStore";

interface ScopeTagsGroupProps {
    questionnaire: Questionnaire | QuestionnaireViewModel;
}

export const ScopeTagsGroup = ({ questionnaire }: ScopeTagsGroupProps) => {
    return (
        <div className="flex flex-row gap-2">
            {questionnaire.questionnaireScopes?.map((scope, i) => (
                <div key={i} className="flex flex-row gap-1 p-1 bg-background rounded-md">
                    <span className="text-sm">{scope.scopeGroup?.name}</span>
                    <span className="text-sm">{scope.formattedSequenceNumber}</span>
                </div>
            ))}
        </div>
    );
};

interface ScopeTagsSequenceProps {
    questionnaire: Questionnaire;
    onChange?: () => void;
}

export const ScopeTagsSequence = ({ questionnaire, onChange }: ScopeTagsSequenceProps) => {
    const [showSetScopeModal, setShowSetScopeModal] = React.useState(false);
    const [selectedScope, setSelectedScope] = React.useState<QuestionnaireScopeAPIModel | null>(null);
    const { user } = useUser();
    const hasScopeAccess = user.hasQuestionnaireAccess(questionnaire, 128);

    const selectScopeToChange = (scope: QuestionnaireScopeAPIModel) => {
        setSelectedScope(scope);
        setShowSetScopeModal(true);
    };

    const scopeGroups = questionnaire.questionnaireType?.scopeTypes?.[0]?.scopeType?.scopeGroups || [];

    return (
        <>
            <div className="flex flex-row gap-2">
                {questionnaire.questionnaireScopes?.map((scope) =>
                    hasScopeAccess && questionnaire.questionnaireType?.scopeTypes?.length > 0 ? (
                        <div
                            key={scope.id}
                            className="group relative flex flex-row gap-1 p-1 bg-background rounded-md border border-brand cursor-pointer hover:bg-background-back transition-colors"
                            onClick={() => selectScopeToChange(scope)}
                            title="Click to change"
                        >
                            <span className="text-sm">
                                {scope.scopeTypeSequence?.name || scope.scopeGroup?.name || scope.scopeTypeSequence?.scopeType?.name}
                            </span>
                            <span className="text-sm">{scope.formattedSequenceNumber}</span>
                        </div>
                    ) : (
                        <div key={scope.id} className="flex flex-row gap-1 p-1 bg-background rounded-md">
                            <span className="text-sm">
                                {scope.scopeTypeSequence?.name || scope.scopeGroup?.name || scope.scopeTypeSequence?.scopeType?.name}
                            </span>
                            <span className="text-sm">{scope.formattedSequenceNumber}</span>
                        </div>
                    )
                )}
            </div>

            <StyledModal isOpen={showSetScopeModal} setIsOpen={setShowSetScopeModal}>
                <div className="flex flex-col gap-2">
                    <p className="text-text">Select a group before continuing</p>
                    <p className="text-status-warning">This will not update existing manifest numbers</p>
                    {scopeGroups.length > 0 && (
                        <div className="border border-border rounded-md overflow-hidden">
                            {scopeGroups.map((item) => (
                                <div
                                    key={item.id}
                                    className="flex items-center justify-between p-3 border-b border-border last:border-b-0 hover:bg-background-back transition-colors"
                                >
                                    <span className="text-text">{item.name}</span>
                                    <button
                                        className="px-3 py-1 bg-brand text-white rounded-md hover:bg-brand-dark transition-colors text-sm"
                                        onClick={() => {
                                            if (selectedScope && questionnaire) {
                                                CreateQuestionnaireScope(questionnaire.id, { scopeGroupID: item.id } as QuestionnaireScopeAPIModel).then(() => {
                                                    DeleteQuestionnaireScope(questionnaire.id, selectedScope?.scopeGroupID).then(() => {
                                                        setShowSetScopeModal(false);
                                                        onChange && onChange();
                                                    });
                                                });
                                            }
                                        }}
                                    >
                                        Select
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </StyledModal>
        </>
    );
};
